import React from 'react';
import { useTranslation } from 'react-i18next';

import Layout from '../Layout/Layout';
import LocationsManager from './LocationsManager';
import { useInHub } from '../../nav/useInHub';

/**
 * Café/standard Locations page (reachable from Schedule → Locations). Wraps the
 * shared LocationsManager; no wall tools for café.
 */
export default function CafeLocations() {
  const { t } = useTranslation();
  const inHub = useInHub();
  return (
    <Layout>
      <div className="container-fluid py-3">
        {!inHub && (
          <h2 className="pp-page-title mb-3">
            <i className="pi pi-map-marker me-2" /> {t('video_wall.locations.title')}
          </h2>
        )}
        <LocationsManager />
      </div>
    </Layout>
  );
}
